var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanVerificationBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8023",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2188 4.00394H5.78128C5.15096 4.00221 4.52656 4.12549 3.9442 4.36664C3.36183 4.60778 2.83306 4.96201 2.38848 5.40883C1.9439 5.85564 1.59233 6.38618 1.3541 6.96975C1.11588 7.55331 0.995732 8.17832 1.00061 8.80862L0.976591 37.6367C0.974398 38.2683 1.09718 38.8941 1.33786 39.478C1.57854 40.0619 1.93237 40.5925 2.37896 41.0391C2.82555 41.4857 3.35609 41.8395 3.94001 42.0802C4.52393 42.3209 5.1497 42.4436 5.78128 42.4414H17.793V37.6367H5.78128V23.2227H49.0235V8.80862C49.0257 8.17705 48.9029 7.55128 48.6622 6.96736C48.4215 6.38343 48.0677 5.8529 47.6211 5.4063C47.1745 4.95971 46.644 4.60588 46.06 4.3652C45.4761 4.12452 44.8504 4.00174 44.2188 4.00394ZM44.2188 13.6133H5.78128V8.80862H44.2188V13.6133ZM32.0389 40.4475L25.2403 33.6489L21.853 37.0362L32.0385 47.2461L49.0235 30.2616L45.6362 26.8742L32.0389 40.4475Z",
    fill: "#1D3A6D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanVerificationBlue);
export default __webpack_public_path__ + "static/media/pan_verification_blue.8e96244b8c6841cda0e5f6295715b412.svg";
export { ForwardRef as ReactComponent };